module.exports = __webpack_public_path__ + "img/monitorbox11.46b02d1d.jpg";